export default __webpack_public_path__ + "static/media/262.c9e52a0b.png";